import script from "./DecorationInspector.vue?vue&type=script&setup=true&lang=js"
export * from "./DecorationInspector.vue?vue&type=script&setup=true&lang=js"

import "./DecorationInspector.vue?vue&type=style&index=0&id=1d991eca&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d991eca"]])

export default __exports__